var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.33,12.88a3.55,3.55,0,0,1-.06-.8,4.94,4.94,0,1,1,9.88,0,4.84,4.84,0,0,1-2.41,4.15,4.28,4.28,0,0,0-2.52,4",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.25,
    cy: 24.31,
    r: 0.44,
    fill: "none",
    stroke: "#3c4347",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.a7c36454c73f92852d15ba57aaa38bd0.svg";
export { ForwardRef as ReactComponent };